import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../context/I18nContext";

// Portrait officiel validé par la fondatrice
const PORTRAIT =
  "https://customer-assets.emergentagent.com/job_gai-editorial/artifacts/4fy44nua_WhatsApp%20Image%202026-04-26%20at%2021.58.08.jpeg";

/**
 * PAGE FONDATRICE — texte strictement validé par la cliente le 24/02/2026.
 * Aucune réécriture ni reformulation autorisée.
 */
export default function Founder() {
  const { lang } = useI18n();

  const bio = {
    fr: [
      "Visionnaire et engagée, elle œuvre à travers le Groupe GAI pour promouvoir une information de qualité, valoriser les talents africains et renforcer les liens entre l'Afrique et sa diaspora.",
      "À travers Global Afrique International, elle porte une vision éditoriale fondée sur l'excellence, l'engagement, la diversité et la valorisation des initiatives qui contribuent au rayonnement de l'Afrique et de sa diaspora.",
    ],
    en: [
      "A visionary and committed leader, she works through the GAI Group to promote quality information, showcase African talent and strengthen the bonds between Africa and its diaspora.",
      "Through Global Afrique International, she carries an editorial vision built on excellence, engagement, diversity and the promotion of initiatives that contribute to Africa's and its diaspora's influence.",
    ],
  };

  const values = [
    { fr: "Excellence", en: "Excellence" },
    { fr: "Engagement", en: "Commitment" },
    { fr: "Diversité", en: "Diversity" },
    { fr: "Rayonnement", en: "Influence" },
  ];

  return (
    <div className="bg-[var(--gai-white)]" data-testid="page-founder">
      <div className="max-w-[1320px] mx-auto px-6 lg:px-10 pt-16 pb-24">
        <div className="overline mb-3">La Fondatrice</div>
        <h1 className="serif text-5xl md:text-7xl leading-[1.02] text-[var(--gai-black)]" translate="no">
          Bijoux Milton Kilandamoko
        </h1>
        <p className="mt-4 text-[0.78rem] tracking-[0.24em] uppercase text-[var(--gai-red)]" translate="no">
          Fondatrice &amp; Éditrice — GLOBAL AFRIQUE INTERNATIONAL
        </p>
        <div className="gai-hairline my-10" />

        <div className="grid lg:grid-cols-12 gap-14 items-start">
          {/* Portrait */}
          <div className="lg:col-span-5 lg:sticky lg:top-28">
            <div className="relative">
              <div className="absolute -inset-5 border border-[var(--gai-grey-300)]" aria-hidden />
              <div className="absolute -top-5 -left-5 w-24 h-1 bg-[var(--gai-red)]" aria-hidden />
              <img
                src={PORTRAIT}
                alt="Bijoux Milton Kilandamoko, fondatrice de Global Afrique International"
                className="relative w-full object-cover"
                style={{ aspectRatio: "4/5" }}
                draggable="false"
                data-testid="founder-portrait"
              />
            </div>

            <div className="mt-8 grid grid-cols-2 gap-3">
              <div className="p-4 bg-[var(--gai-white)] border border-[var(--gai-grey-200)]">
                <div className="overline text-[var(--gai-red)] mb-2">
                  {lang === "fr" ? "Fondation" : "Founded"}
                </div>
                <div className="text-lg serif text-[var(--gai-black)]">2011</div>
              </div>
              <div className="p-4 bg-[var(--gai-white)] border border-[var(--gai-grey-200)]">
                <div className="overline text-[var(--gai-red)] mb-2">
                  {lang === "fr" ? "Groupe" : "Group"}
                </div>
                <div className="text-sm text-[var(--gai-black)]" translate="no">Global Afrique International</div>
              </div>
            </div>
          </div>

          {/* Bio + valeurs */}
          <div className="lg:col-span-7">
            <div className="p-8 md:p-10 border border-[var(--gai-grey-200)] bg-[var(--gai-white)]">
              <div className="overline text-[var(--gai-red)] mb-4">
                {lang === "fr" ? "Présentation" : "About"}
              </div>
              <div className="space-y-5 text-lg leading-relaxed text-[var(--gai-grey-800)]" data-testid="founder-bio">
                <p>
                  <strong className="text-[var(--gai-black)] font-semibold" translate="no">
                    Bijoux Milton Kilandamoko
                  </strong>{" "}
                  — <em>{lang === "fr"
                    ? "Fondatrice et Éditrice du Groupe Global Afrique International (GAI)"
                    : "Founder and Editor of the Global Afrique International (GAI) Group"}</em>.
                </p>
                {(lang === "fr" ? bio.fr : bio.en).map((p, i) => (
                  <p key={i}>{p}</p>
                ))}
              </div>
            </div>

            {/* Valeurs éditoriales */}
            <div className="mt-8">
              <div className="overline mb-4 text-[var(--gai-red)]">
                {lang === "fr" ? "Vision éditoriale" : "Editorial vision"}
              </div>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                {values.map((v, i) => (
                  <div key={i} className="p-5 border border-[var(--gai-grey-200)] bg-[var(--gai-white)] text-center">
                    <div className="serif text-2xl text-[var(--gai-black)]">{lang === "fr" ? v.fr : v.en}</div>
                  </div>
                ))}
              </div>
            </div>

            <div className="mt-10 flex flex-wrap gap-3">
              <Link to="/edito" className="gai-btn-gold" data-testid="founder-cta-edito">
                {lang === "fr" ? "Lire l'édito de la Direction" : "Read the editorial"}
              </Link>
              <Link to="/rendez-vous" className="gai-btn-outline" data-testid="founder-cta-rdv">
                {lang === "fr" ? "Réserver un entretien privé" : "Book a private meeting"}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
